import { useMemo } from "react";
import { useParticipants, useRemoteParticipants } from "@livekit/components-react";
import { withoutCallMonitor } from "../lib/callMonitor";

/**
 * LiveKit's participant hooks with the staging call monitor left out (see
 * lib/callMonitor.ts). Use these wherever people are shown or counted; for
 * track lists, wrap `useTracks` in `tracksWithoutCallMonitor`.
 */
export function useVisibleParticipants() {
  const participants = useParticipants();
  return useMemo(() => withoutCallMonitor(participants), [participants]);
}

export function useVisibleRemoteParticipants() {
  const participants = useRemoteParticipants();
  return useMemo(() => withoutCallMonitor(participants), [participants]);
}
